import React, { Component } from 'react'
import history from '../../../routes/history';
import connectCommon from '../../common/common-hoc';
import { connect } from 'react-redux'
import * as actionCreatorData from '../../../redux/actions/data-action';
import * as actionCreatorLookup from '../../../redux/actions/lookup-action';
import { isFetchingLookups, getLookup, getLookupErrors, LOOKUP_GENDER, LOOKUP_COUNTRY, LOOKUP_STATE, LOOKUP_HISPANIC, LOOKUP_RACE_COUNTRY, LOOKUP_EDUCATION, LOOKUP_PROVINCE, LOOKUP_ABORIGINAL } from '../../../redux/actions/lookup-action';

import { Box } from '../../../third-party-components/material-ui';
import { DemoContainer, DemoQuestionText, DemoQuestionDatePicker, DemoQuestionDropDownList, DemoQuestionRadioButtons } from '../common/controls';

import { calcAge } from '../demographic-functions';
import { config } from '../../../Constants';

import {
    AssessmentContentHeader
} from '../../assessment/common';
import DemoHideabletext from '../common/controls/demo-hideable-text';

const MIN_AGE = 18;
const prevLink = '/TermsAndConditions';
const nextLink = '/Assessment/Instruction';

const terminationLink = '/Terminate/Demographics';
const defaultNullSelectValue = '--Please Select--';

const errors = {
    firstNameError: '',
    lastNameError: '',
    idError: '',
    dobError: '',
    ageError: '',
    genderOtherError: '',
    countryOtherError: '',
    stateOtherError: '',
    hispanicOtherError: '',
    raceOtherError: '',
    PELOtherError: ''
}

class DemographicRatee extends Component {
  constructor(props) {
    super(props);

    this.state = { errors };

    this.onChange = this.onChange.bind(this);
    this.handleNext = this.handleNext.bind(this);
  }

componentDidMount() {
  const { getGenderOptions, getCountryOptions, getStateOptions, getHispanicOptions, getEducationOptions, getProvinceOptions, getAboriginalOptions } = this.props;

  getGenderOptions();
  getCountryOptions();
  getStateOptions();
  getHispanicOptions();
  getEducationOptions();
  getProvinceOptions();
  getAboriginalOptions();

  window.history.pushState(null, null, history.location.href);
  window.onpopstate = function(event) {
      history.go(1);
  };
}

handleNext() {
  if (this.validateAll()) {
    history.push(nextLink);
  }
}

onChange(e) {
  const { setDemographicsResponse, getRaceCountryOptions } = this.props;
  const {name, selectedValue, value} = e.target;

  switch(name) {
    case 'rateeAge':
      if (isNaN(value)) return;
      this.setState({dobError: ''})
      break;
    case 'rateeDOB':
      this.setState({dobError: ''})

      this.props.demographics.rateeAge = calcAge(value)
      break;
    case 'rateeFirstName':
    case 'rateeLastName':
    case 'rateeID':
      this.setState({firstNameError: ''})
      break;
    case 'rateeCountry':
      getRaceCountryOptions(value);
      this.props.demographics.rateeRace = null;
      this.props.demographics.rateeRaceOtherSP = null;
      break;
    default:
      this.validate(name, selectedValue || value)
      break;
  }

  setDemographicsResponse(name, value === defaultNullSelectValue ? null : value);
}

validateAll() {
  return this.validateFirstLastNameID()
    & this.validateAgeDOB();
}

validate(name, value) {
  switch (name) {
    // case 'rateeGenderOtherSP':
    //   return this.validateGenderOther(value);
    case 'rateeCountryOtherSP':
      return this.validateCountryOther(value);
    case 'rateeStateOtherSP':
      return this.validateStateOther(value);
    case 'rateeHispanicOtherSP':
      return this.validateHispanicOther(value);
    case 'rateeRaceOtherSP':
      return this.validateRaceOther(value);
    case 'rateePELOtherSP':
      return this.validatePELOther(value);
    default:
      return true;
  }
}

validateFirstLastNameID() {
  const {rateeFirstName, rateeLastName, rateeID} = this.props.demographics;

  if ((rateeFirstName === "" || rateeLastName === "") || (rateeFirstName === null || rateeLastName === null)) {
    if (rateeID !== "" && rateeID !== null) {
      this.setState({firstNameError: ''})
      return true;
    }
    else {
      this.setState({firstNameError: 'Prénom et nom/Numéro d\'identification de l\'enfant constitue un renseignement obligatoire'})
      return false;
    }
  }
  this.setState({firstNameError: ''})
  return true;
}

validateAgeDOB() {
  const {rateeAge, rateeDOB} = this.props.demographics;

  if (rateeAge === "" || rateeAge === null) {
    if (rateeDOB !== "" && rateeDOB !== null) {
      this.setState({dobError: ''})
      return true;
    }
    else {
      this.setState({dobError: 'Date de naissance/Âge un renseignement obligatoire'})
      return false;
    }
  }

  var max = new Date();

  if (config.datePickerMax) {
    try {
        max = new Date(Date.parse(config.datePickerMax));
    } catch {

    }
  }

  if (rateeDOB > max) {
    this.setState({dobError: 'La date de naissance doit être antérieur à la date d\'aujourd\'hui.'})
    return false;
  }

  if (rateeAge !== "" && rateeAge !== null && rateeDOB !== "" && rateeDOB !== null) {
    if (calcAge(rateeDOB) !== parseInt(rateeAge)) {
      this.setState({dobError: "La date de naissance et l'âge ne correspondent pas."})
      return false;
    }
  }
  
  this.setState({dobError: ''})
  return true;
}

// validateGenderOther(value) {
//   if (this.requireGenderOther()) {
//     if (!value || value.trim().length === 0) {
//       this.setState({ genderOtherError: 'Please provide a response'})
//       return false;
//     }
//   }

//   this.setState({ genderOtherError: ''})
//   return true;
// }

validateCountryOther(value) {
  if (this.requireCountryOther()) {
    if (!value || value.trim().length === 0) {
      this.setState({ countryOtherError: 'Please provide a response'})
      return false;
    }
  }

  this.setState({ countryOtherError: ''})
  return true;
}

validateStateOther(value) {
  if (this.requireStateOther()) {
    if (!value || value.trim().length === 0) {
      this.setState({ stateOtherError: 'Please provide a response'})
      return false;
    }
  }

  this.setState({ stateOtherError: ''})
  return true;
}

validateHispanicOther(value) {
  if (this.requireHispanicOther()) {
    if (!value || value.trim().length === 0) {
      this.setState({ hispanicOtherError: 'Please provide a response'})
      return false;
    }
  }

  this.setState({ hispanicOtherError: ''})
  return true;
}

validateRaceOther(value) {
  if (this.requireRaceOther()) {
    if (!value || value.trim().length === 0) {
      this.setState({ raceOtherError: 'Please provide a response'})
      return false;
    }
  }

  this.setState({ raceOtherError: ''})
  return true;
}

validatePELOther(value) {
  if (this.requireEDUOther()) {
    if (!value || value.trim().length === 0) {
      this.setState({ PELOtherError: 'Please provide a response'})
      return false;
    }
  }

  this.setState({ PELOtherError: ''})
  return true;
}

requireFirstLastID(callingField) {
  const { rateeFirstName, rateeLastName, rateeID } = this.props.demographics;

  var required = true;

  if (rateeFirstName !== null && rateeFirstName !== "" && rateeLastName !== null && rateeLastName !== "" && rateeID !== null && rateeID !== "") {
    return true;
  }

  if (rateeFirstName !== null && rateeLastName !== null) {
    if (rateeFirstName !== "" && rateeLastName !== "") {
      if (callingField !== "rateeFirstName" && callingField !== "rateeLastName") {
        required = false;
      }
    }
  }

  if (rateeID !== null) {
    if (rateeID !== "") {
      if (callingField !== "rateeID") {
        required = false;
      }
    }
  }

  return required;
}

requireDOBAge(callingField) {
  const { rateeDOB, rateeAge } = this.props.demographics;

  var required = true;

  if (rateeDOB !== null && rateeDOB !== "" && rateeAge !== null && rateeAge !== "") {
    return true;
  }

  if (rateeDOB !== null) {
    if (rateeDOB !== "") {
      if (callingField !== "rateeDOB") {
        required = false;
      }
    }
  }

  if (rateeAge !== null) {
    if (rateeAge !== "") {
      if (callingField !== "rateeAge") {
        required = false;
      }
    }
  }

  return required;
}

requireGenderOther() {
  const { rateeGender } = this.props.demographics;

  var required = false;

  if (isNaN(rateeGender) && rateeGender === defaultNullSelectValue) {
      return false;
  }

  if (rateeGender) {
    
      const value =  parseInt(rateeGender)
      const option = this.getGenderOption(value);

      if (option) {
        required = option.requireOther;
      }
  }

  if (!required) {
    this.props.demographics.rateeGenderOtherSP = null;
  }

  return required;
}

requireCountryOther() {
  const { rateeCountry } = this.props.demographics;

  var required = false;

  if ((isNaN(rateeCountry) && rateeCountry === defaultNullSelectValue)) {
    return false;
  }

  if (rateeCountry) {
    const value = parseInt(rateeCountry);
    const option = this.getCountryOption(value);

    if (option) {
      required = option.requireOther;
    }
  }

  if (!required) {
    this.props.demographics.rateeCountryOtherSP = null;
  }

  return required;
}

requireState() {
  const countryOption = this.getSelectedCountryOption();

  var required = false;

  if (countryOption) {
      if (!countryOption.requireState) {
          required =  false;
      } else {
          required = true
      }
  }

  if (!required) {
    this.props.demographics.rateeState = null;
  }

  return required;
}

requireStateOther() {
  const { rateeState } = this.props.demographics;

  var required = false;

  if ((isNaN(rateeState) && rateeState === defaultNullSelectValue)) {
      return false;
  }

  if (rateeState) {
    const value = parseInt(rateeState);
    const option = this.getStateOption(value);

    if(option) {
      required = option.requireOther;
    }
  }

  if (!required) {
    this.props.demographics.rateeStateOtherSP = null;
  }

  return required;
}

requireHispanic() {
  const { rateeCountry } = this.props.demographics;

  var required = false;

  if (isNaN(rateeCountry) && rateeCountry === defaultNullSelectValue) {
    return false;
  }

  if (rateeCountry) {
    const value = parseInt(rateeCountry)
    
    if (parseInt(value) === 1) {
      required = true;
    } 
  }

  if (!required) {
    this.props.demographics.rateeHispanic = null;
  }

  return required;
}

requireHispanicOther() {
  const { rateeHispanic, rateeCountry } = this.props.demographics;

  var required = false;

  if ((isNaN(rateeHispanic) && rateeHispanic === defaultNullSelectValue) || (parseInt(rateeCountry) !== 1)) {
     return false;
  }

  if (rateeHispanic) {
    const value = parseInt(rateeHispanic);
    const option = this.getHispanicOption(value);

    required = option && option.requireOther;
  }

  if (!required) {
    this.props.demographics.rateeHispanicOtherSP = null;
  }

  return required;
}

requireRace() {
  const { rateeCountry, rateeAboriginal } = this.props.demographics;

  var required = false;
  var countryOk = false;
  var aboriginalOk = false;

  if ((isNaN(rateeCountry) && rateeCountry === defaultNullSelectValue)) {
    return false;
  }

  if (rateeCountry) {
    const value = parseInt(rateeCountry);

    if (value !== 3) {
      countryOk = true;
    }
  }

  if (rateeAboriginal) {
    const value = parseInt(rateeAboriginal);

    if (value === 1) {
      aboriginalOk = true;
    }
  }

  required = countryOk && (parseInt(rateeCountry) === 2 ? aboriginalOk : true);

  if (!required) {
    this.props.demographics.rateeRace = null;
  }

  return required;
}

requireRaceOther() {
  const { rateeRace } = this.props.demographics;

  var required = false;

  if (isNaN(rateeRace) && rateeRace === defaultNullSelectValue) {
      return false;
  }

  if (rateeRace) {
      const value =  parseInt(rateeRace)
      const option = this.getRaceOption(value);

      if (option) {
        required = option.requireOther
      }
  }

  if (!required) {
    this.props.demographics.rateeRaceOtherSP = null;
  }

  return required;
}

requireEDU() {
  const { rateeCountry } = this.props.demographics;

  var required = false;

  if (isNaN(rateeCountry) && rateeCountry === defaultNullSelectValue) {
    return false;
  }

  if (rateeCountry) {
    const value = parseInt(rateeCountry)
    
    if (value !== 3) {
      required = true;
    }
  }

  if (!required) {
    this.props.demographics.rateePEL = null;
  }

  return required;
}

requireEDUOther() {
  const { rateePEL } = this.props.demographics;

  var required = false;

  if (isNaN(rateePEL) && rateePEL === defaultNullSelectValue) {
    return false;
  }

  if (rateePEL) {
    const value = parseInt(rateePEL);
    const option = this.getEduOption(value);

    if (option) {
      required = option.requireOther;
    }
  }

  if (!required) {
    this.props.demographics.rateePELOtherSP = null;
  }

  return required;
}

requireProvince() {
  const countryOption = this.getSelectedCountryOption();

  var required = false;

  if (countryOption) {
      if (!countryOption.requireProvince) {
          required =  false;
      } else {
          required = true
      }
  }

  if (!required) {
    this.props.demographics.rateeProvince = null;
  }

  return required;
}

requireAboriginal() {
  const { rateeCountry } = this.props.demographics;

  var required = false;

  if (isNaN(rateeCountry) && rateeCountry === defaultNullSelectValue) {
    return false;
  }

  if (rateeCountry) {
    const value = parseInt(rateeCountry)
    
    if (parseInt(value) === 2) {
      required = true;
    } 
  }

  if (!required) {
    this.props.demographics.rateeAboriginal = null;
  }

  return required;
}

getGenderOption(value) {
  const { genderOptions } = this.props;
  return genderOptions.find((option) => option.value === value);
}

getCountryOption(value) {
  const {countryOptions} = this.props;
  return countryOptions.find((option) => option.value === value);
}

getStateOption(value) {
  const {stateOptions} = this.props;
  return stateOptions.find((option) => option.value === value);
}

getHispanicOption(value) {
  const { hispanicOptions } = this.props;
  return hispanicOptions.find((option) => option.value === value);
}

getRaceOption(value) {
  const { raceOptions } = this.props;
  return raceOptions.find((option) => option.value === value);
}

getEduOption(value) {
  const { eduOptions } = this.props;
  return eduOptions.find((option) => option.value === value);
}

getSelectedCountryOption() {
  const { countryOptions } = this.props;
  const { rateeCountry } = this.props.demographics;

  if (rateeCountry) {
    return countryOptions.find((option) => { return option.value === parseInt(rateeCountry); });
  }

  return null;
}

getSelectedStateOption() {
  const { stateOptions } = this.props;
  const { rateeState } = this.props.demographics;

  if (rateeState) {
      return stateOptions.find((option) => { return option.value === parseInt(rateeState); });
  }

  return null;
}

getFieldValue(value) {
  var fieldValue = ""

  if (value) {
    if (value != null) {
      fieldValue = value;
    }
  }

  return fieldValue;
}

render() {
  const { 
      demographics, 
      genderOptions, 
      countryOptions, 
      stateOptions, 
      hispanicOptions,
      raceOptions,
      eduOptions,
      provinceOptions,
      aboriginalOptions
  } = this.props;

  return (
      <DemoContainer title='Jeune  Décrit(e)' onNextClick={this.handleNext}>
          <Box display="flex" flexDirection="column" style={{paddingBottom: '20px'}}>
            <div style={{marginBottom: '10px'}}>Veuillez fournir les renseignements démographiques suivants concernant le/la jeune.</div>
            <span><span className="label-required">*</span> Renseignement obligatoire</span>
          </Box>
          <Box style={{width:'100%'}}>
              <Box className='input-group blue'>
                  <DemoQuestionText
                      name="rateeFirstName"
                      label="Prénom:"
                      
                      value={this.getFieldValue(demographics['rateeFirstName'])}
                      required={this.requireFirstLastID("rateeFirstName")}
                      onChange={this.onChange}
                      inputProps={{maxLength:'35'}}
                      validationMessage={this.state.firstNameError}/>
              <DemoQuestionText
                      name="rateeLastName"
                      label="Nom de famille:"
                      
                      value={this.getFieldValue(demographics['rateeLastName'])}
                      required={this.requireFirstLastID("rateeLastName")}
                      onChange={this.onChange}
                      inputProps={{maxLength:'35'}}
                      validationMessage={this.state.lastNameError}/>
              </Box>
              <Box className="or-box" data-content='OU'/>
              <Box className='input-group blue'>
                  <DemoQuestionText
                      name="rateeID"
                      label="Numéro d’identification:"
                      
                      value={this.getFieldValue(demographics['rateeID'])}
                      required={this.requireFirstLastID("rateeID")}
                      onChange={this.onChange}
                      inputProps={{maxLength:'20'}}
                      validationMessage={this.state.idError}/>
              </Box>
          </Box>
          <Box style={{width:'100%'}}>
              <Box className='input-group' style={{float:'left'}}>
                  <DemoQuestionDatePicker
                      name="rateeDOB"
                      lang="fr"
                      label="Date de naissance:"
                      required={this.requireDOBAge("rateeDOB")}
                      value={this.getFieldValue(demographics["rateeDOB"])}
                      onChange={this.onChange}
                      validationMessage={this.state.dobError}
                  />
              </Box>
              <Box className='input-group' style={{float:'right'}}>
                <div style={{width:'30%'}}>
                  <DemoQuestionText
                      name="rateeAge"
                      label="Âge:"
                      required={this.requireDOBAge("rateeAge")}
                      value={this.getFieldValue(demographics["rateeAge"])}
                      onChange={this.onChange}
                      inputProps = {{maxLength: '3'}}
                      validationMessage={this.state.ageError} />
                </div>
              </Box>
          </Box>
          <Box style={{width:'100%'}}>
              <Box className='input-group' style={{float:'left'}}>
                  <DemoQuestionDropDownList
                      name="rateeGender"
                      label="Genre:"
                      value={this.getFieldValue(demographics['rateeGender'])}
                      data={genderOptions}
                      textField="text"
                      dataItemKey="value"
                      onChange={this.onChange} />
              </Box>
              <Box className='input-group' style={{float:'right'}}>
                  <DemoQuestionText
                      name="rateeGenderOtherSP"
                      label="Veuillez préciser:"
                      className="demo-text-other"
                      visible={this.requireGenderOther()}
                      value={this.getFieldValue(demographics["rateeGenderOtherSP"])}
                      onChange={this.onChange}
                      inputProps = {{maxLength:'30'}}
                      validationMessage={this.state.genderOtherError} />
              </Box>
          </Box>
          <Box style={{width:'100%'}}>
            <div style={{width:'30%'}}>
              <Box className='input-group'>
                  <DemoQuestionText 
                      name="rateeGrade" 
                      label="Année d'études:"
                      
                      value={this.getFieldValue(demographics["rateeGrade"])}
                      onChange={this.onChange}
                      inputProps={{maxLength:'50'}} />
              </Box>
            </div>
          </Box>
          <Box className='ratee-additional-box'>
            <p><b>INFORMATION ADDITIONELLE</b></p>
            Ces questions facultatives vous sont posées aux fins de recherche uniquement. L'administrateur ne pourra pas voir vos réponses.
          </Box>
          <Box style={{width:'100%'}}>
                  <DemoQuestionDropDownList
                      name="rateeCountry"
                      label="Où vit le/la jeune actuellement? Pays:"
                      value={this.getFieldValue(demographics["rateeCountry"])}
                      data={countryOptions}
                      textField="text"
                      dataItemKey="value"
                      onChange={this.onChange} />
                  <DemoQuestionText
                      name="rateeCountryOtherSP"
                      label="Veuillez préciser:"
                      className="demo-text-other"
                      
                      visible={this.requireCountryOther()}
                      value={this.getFieldValue(demographics["rateeCountryOtherSP"])}
                      onChange={this.onChange}
                      inputProps = {{maxLength:'30'}}
                      validationMessage={this.state.countryOtherError} />
                  <DemoQuestionDropDownList
                      name="rateeState"
                      label="Où vit le/la jeune actuellement? État:"
                      value={this.getFieldValue(demographics["rateeState"])}
                      visible={this.requireState()}
                      data={stateOptions}
                      textField="text"
                      dataItemKey="value"
                      onChange={this.onChange} />
                  <DemoQuestionDropDownList
                      name="rateeProvince"
                      label=". Où vit le/la jeune actuellement? Province:"
                      value={this.getFieldValue(demographics["rateeProvince"])}
                      visible={this.requireProvince()}
                      data={provinceOptions}
                      textField="text"
                      dataItemKey="value"
                      onChange={this.onChange} />
                  <DemoQuestionText
                      name="rateeStateOtherSP"
                      label="Veuillez préciser:"
                      className="demo-text-other"
                      
                      visible={this.requireStateOther()}
                      value={this.getFieldValue(demographics["rateeStateOtherSP"])}
                      onChange={this.onChange}
                      inputProps = {{maxLength:'30'}}
                      validationMessage={this.state.stateOtherError} />
          </Box>
          <Box style={{width:'100%'}}>
              <DemoQuestionDropDownList
                  name="rateeHispanic"
                  label="Le/La jeune est-il/elle d'origine hispanique, latine ou espagnole?"
                  value={this.getFieldValue(demographics["rateeHispanic"])}
                  data={hispanicOptions}
                  visible={this.requireHispanic()}
                  textField="text"
                  dataItemKey="value"
                  onChange={this.onChange} />
              <DemoQuestionDropDownList
                  name="rateeAboriginal"
                  label="Le/La jeune est-il/elle Autochtone, c'est-à-dire issu(e) des Premières Nations (Indiens d'Amérique du Nord), Métis ou Inuk (Inuit)?"
                  value={this.getFieldValue(demographics["rateeAboriginal"])}
                  data={aboriginalOptions}
                  visible={this.requireAboriginal()}
                  textField="text"
                  dataItemKey="value"
                  onChange={this.onChange} />
              <DemoQuestionText
                  name="rateeHispanicOtherSP"
                  label="Veuillez préciser:"
                  className="demo-text-other"
                  
                  visible={this.requireHispanicOther()}
                  value={this.getFieldValue(demographics["rateeHispanicOtherSP"])}
                  onChange={this.onChange}
                  inputProps = {{maxLength:'30'}}
                  validationMessage={this.state.hispanicOtherError} />
          </Box>
          <Box style={{width:'100%'}}>
              <DemoQuestionDropDownList
                  name="rateeRace"
                  label="Ethnicité:"
                  value={this.getFieldValue(demographics["rateeRace"])}
                  data={raceOptions}
                  visible={this.requireRace()}
                  textField="text"
                  dataItemKey="value"
                  onChange={this.onChange} />
              <DemoQuestionText
                  name="rateeRaceOtherSP"
                  label="Veuillez préciser:"
                  className="demo-text-other"
                  
                  visible={this.requireRaceOther()}
                  value={this.getFieldValue(demographics["rateeRaceOtherSP"])}
                  onChange={this.onChange}
                  inputProps = {{maxLength:'30'}}
                  validationMessage={this.state.raceOtherError} />
          </Box>
          <DemoHideabletext visible={this.requireEDU()}>
            <b><small>Le parent/tuteur(trice) principal(e) se définit comme la personne responsable des soins et de l'éducation<br/>
            de l'enfant. Si la responsabilité des soins et de l'éducation est partagée également, le parent/tuteur(trice)<br/>
            qui effectue cette évaluation est considéré(e) comme le/la responsable principal(e).</small></b>
          </DemoHideabletext>
          <Box style={{width:'100%'}}>
                  <DemoQuestionDropDownList
                      name="rateePEL"
                      label="Plus haut niveau d'études terminé par le parent principal:"
                      value={this.getFieldValue(demographics["rateePEL"])}
                      visible={this.requireEDU()}
                      data={eduOptions}
                      textField="text"
                      dataItemKey="value"
                      onChange={this.onChange} />
                  <DemoQuestionText
                    name="rateePELOtherSP"
                    label="Veuillez préciser:"
                    className="demo-text-other"
                    
                    visible={this.requireEDUOther()}
                    value={this.getFieldValue(demographics["rateePELOtherSP"])}
                    onChange={this.onChange}
                    inputProps = {{maxLength:'30'}}
                    validationMessage={this.state.PELOtherError} />
          </Box>
      </DemoContainer>
    )
  } 
}

const mapStateToProps = (state, ownState) => ({
  demographics: state.data.demographics,
  genderOptions: getLookup(state, LOOKUP_GENDER),
  countryOptions: getLookup(state, LOOKUP_COUNTRY),
  stateOptions: getLookup(state, LOOKUP_STATE),
  hispanicOptions: getLookup(state, LOOKUP_HISPANIC),
  raceOptions: getLookup(state, LOOKUP_RACE_COUNTRY),
  eduOptions: getLookup(state, LOOKUP_EDUCATION),
  provinceOptions: getLookup(state, LOOKUP_PROVINCE),
  aboriginalOptions: getLookup(state, LOOKUP_ABORIGINAL),
  optionErrors: getLookupErrors(state, [LOOKUP_GENDER, LOOKUP_COUNTRY, LOOKUP_STATE, LOOKUP_HISPANIC, LOOKUP_RACE_COUNTRY, LOOKUP_EDUCATION, LOOKUP_PROVINCE, LOOKUP_ABORIGINAL]),
  isFetching: isFetchingLookups(state, [LOOKUP_GENDER, LOOKUP_COUNTRY, LOOKUP_STATE, LOOKUP_HISPANIC, LOOKUP_RACE_COUNTRY, LOOKUP_EDUCATION, LOOKUP_PROVINCE, LOOKUP_ABORIGINAL])
})

export default connect(mapStateToProps, Object.assign({}, actionCreatorData, actionCreatorLookup))(connectCommon(DemographicRatee));